export const GET_ALL_AUDIT_USER_REQUEST = " GET_ALL_AUDIT_USER_REQUEST";
export const GET_ALL_AUDIT_USER_SUCCESS = " GET_ALL_AUDIT_USER_SUCCESS";
export const GET_ALL_AUDIT_USER_FAILURE = " GET_ALL_AUDIT_USER_FAILURE";
